import { Address } from '../types/quoteTypes'

export const postcodeSearch = async (postcode: string): Promise<Address[]> => {
  const response = await fetch(`https://api.postcodes.io/postcodes/${postcode.replace(/\s/g, '')}`)

  if (!response.ok) {
    throw new Error('Postcode not found')
  }

  const data = await response.json()

  if (data.status === 200 && data.result) {
    return [{
      id: data.result.postcode,
      formatted_address: [
        data.result.postcode,
        data.result.admin_district,
        data.result.country,
      ].filter(Boolean),
      postcode: data.result.postcode,
    }]
  }

  return []
}
